import { Page } from "../../components/page/page";
import { StatusMessage } from "../../components/status-message/statusMessage";
import { useApp } from "../../hooks/use-app/useApp";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { useQuery } from "../../hooks/use-query/useQuery";

export const WrongEmail: React.FC = () => {
  const { localize } = useLocalization();
  const query = useQuery();
  const app = useApp();

  return (
    <Page>
      <StatusMessage type="error">
        <p>{localize("error:wrongEmail")}</p>
        <p>
          {localize("correctEmail")}: <b>{query.email}</b>
        </p>
        <p>
          {localize("wrongEmail")}: <b>{query.loggedInEmail}</b>
        </p>
      </StatusMessage>
      <a
        className="button"
        href={`/${app.name}/registrer?email=${query.email ? encodeURIComponent(query.email) : ""}&invite=${query.invite}`}
      >
        {localize("back")}
      </a>
    </Page>
  );
};
